import { ApplicationFlowTheme } from '../types'
import { getApplicationFlowTheme } from './application-flow-theme'

interface DownloadChannelPresentationConfig {

  /** 下载页主题的唯一选择依据。 */
  channelTemplate?: unknown

  /** 品牌展示字段；仅决定文案，不参与主题解析。 */
  showChannelName?: unknown
}

export interface DownloadPresentation {

  /** 旧容器需要展示的品牌文案。 */
  brandName: '聚融易' | '聚好借'

  /** 是否按聚好借品牌展示专属标识，由 showChannelName 映射，供旧容器直接传入皮肤 ViewModel。 */
  isJhjBrand: boolean

  /** 由渠道模板解析出的下载页主题。 */
  theme: ApplicationFlowTheme
}

/**
 * resolveDownloadPresentation — 将渠道详情映射为注册成功下载页的纯展示配置。
 * channelTemplate 唯一决定主题，showChannelName 只决定品牌；不完整配置返回 null，避免猜测下载页展示语义。
 * @param {unknown} detail 旧注册成功容器取得的渠道详情
 * @returns {DownloadPresentation | null} 有效的 v2 下载展示配置，或保持旧展示的 null
 */
export const resolveDownloadPresentation = (detail: unknown): DownloadPresentation | null => {
  const config = detail && typeof detail === 'object' ? detail as DownloadChannelPresentationConfig : null
  const theme = getApplicationFlowTheme(config?.channelTemplate)

  if (!theme) {
    return null
  }
  const showChannelName = config?.showChannelName

  if (showChannelName === 1) {
    return {
      brandName: '聚融易',
      isJhjBrand: false,
      theme,
    }
  }
  if (showChannelName === 2) {
    return {
      brandName: '聚好借',
      isJhjBrand: true,
      theme,
    }
  }

  return null
}
